import { CommonModule, isPlatformBrowser, isPlatformServer } from "@angular/common";
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Client, FullScreenJobHeaderPageComponent, HeaderPageComponent, JdMainHeaderPageComponent, Video } from "@interfaces";
import { AbstractVideoComponent } from "../../abstract-video-component";

@Component({
    selector: "app-header-video",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./header-video.component.html",
})
export class HeaderVideoComponent extends AbstractVideoComponent implements OnInit, AfterViewInit {
    @Input() client: Client;
    @Input() component: HeaderPageComponent | FullScreenJobHeaderPageComponent | JdMainHeaderPageComponent;
    @Input() mobileMode: boolean;
    @Input() aspectClasses = ['md:aspect-auto', 'aspect-square'];
    @ViewChild("videoElement", { read: ElementRef, static: false })
    public videoElement: ElementRef;
    public showNativeControls = false;

    ngOnInit() {
        if (isPlatformServer(this.platform)) {
            this.videosService.resolveVideo(this.component.video).subscribe(() => {});
        }
    }

    ngAfterViewInit() {
        let video;

        if(this.mobileMode && this.component['mobileVideo']) {
            video = this.component['mobileVideo'];
        }
        else {
            video = this.component?.['source'] === "job" && this.job?.video ? this.job.video : this.component.video;
        }
        if (isPlatformBrowser(this.platform) && video) {
            this.videosService.resolveVideo(video).subscribe(
                (video: Video) => {
                    this.loading = false;
                    this.subtitles = video.subtitles;
                    this.playlist = video.playlistData;
                    this.originVideo = video;
                    this.videoData = video;
                    this.loadVideo(this.videoData);
                },
                (error) => {
                    this.loading = false;
                    this.error = true;
                }
            );
        }
    }
}
